import React from 'react'
import classnames from 'classnames'
import Draggable, { DraggableBounds } from 'react-draggable'
import { ResizeInfo } from 'types'

import styles from './styles.module.css'

// yep, 2018 and we still have to do browser detection.
const isIE = () => {
  if (typeof window !== 'undefined') {
    const ua = window.navigator.userAgent
    const msie = ua.indexOf('MSIE ')
    if (msie > 0) {
      // IE 10 or older
      return true
    }

    const trident = ua.indexOf('Trident/')
    if (trident > 0) {
      // IE 11
      return true
    }

    const edge = ua.indexOf('Edge/')
    if (edge > 0) {
      // Edge (IE 12+)
      return true
    }
  }
  return false
}

// SVG drag handle does not work in IE, so we use this crappy text approximation
// otherwise go with the sexy svg
const defaultDragHandleIcon = isIE() ? (
  <div className={classnames('column-drag-handle', styles.columnDragHandle)}>
    ||
  </div>
) : (
  <svg
    className={classnames('column-drag-handle', styles.columnDragHandle)}
    width='6px'
    height='24px'
  >
    <g
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      strokeLinecap='square'
    >
      <g transform='translate(-0.500000, 1.000000)' stroke='#D8D3D3'>
        <g>
          <path d='M1.5,0 L1.5,21.5' strokeWidth='2' />
          <path d='M5.5,0 L5.5,21.5' strokeWidth='2' />
        </g>
      </g>
    </g>
  </svg>
)

export interface Props {
  bounds: DraggableBounds
  columnKey: string
  dragHandleIcon?: JSX.Element
  onDragStart: (data: ResizeInfo) => void
  onDragStop: (data: ResizeInfo) => void
}

const ColumnDragHandle = ({
  bounds,
  columnKey,
  dragHandleIcon = defaultDragHandleIcon,
  onDragStart = () => {},
  onDragStop = () => {}
}: Props) => (
  <Draggable
    axis='x'
    bounds={bounds}
    defaultClassName='DragHandle'
    defaultClassNameDragging='DragHandleActive'
    // @ts-ignore
    onStart={(event, data) =>
      onDragStart({
        data,
        columnKey
      })
    }
    // @ts-ignore
    onStop={(event, data) =>
      onDragStop({
        data,
        columnKey
      })
    }
    position={{
      x: 0,
      y: 0
    }}
  >
    {dragHandleIcon}
  </Draggable>
)

export default ColumnDragHandle
